@if (!isMobile()) {
  <mat-card-header class="p-0 flex justify-between items-center">
    <mat-card-title>Rooms</mat-card-title>
    <a
      class="btn-base border border-ui-gray-150 px-2 py-1 text-ui-gray-250 text-sm font-normal cursor-pointer"
      [routerLink]="['/dashboard', locationId(), floorId(), 'edit']"
      avsRestrictedEl
    >
      <mat-icon matPrefix>add</mat-icon>
      Add Room
    </a>
  </mat-card-header>
}
<mat-card-content class="p-0 overflow-x-auto">
  <div class="flex justify-between mb-4 border-b">
    @if (!isMobile()) {
      <mat-button-toggle-group
        class="desktop-toggle-group"
        (change)="statusFilter.set($event.value)"
        [value]="statusFilter()"
        aria-label="Room Status"
        name="room-status"
      >
        <mat-button-toggle
          class="test-room-status-open"
          value="open"
        >
          <span class="item-status-title">Current</span>
        </mat-button-toggle>
        <mat-button-toggle
          class="test-room-status-history"
          value="history"
        >
          <span class="item-status-title">Archived</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    }
    <div
      class="flex items-center"
      [class.w-full]="isMobile()"
    >
      <app-search-input
        (searchDataEvent)="search.set($event)"
        [class.w-full]="isMobile()"
        [inputWidth]="isMobile() ? '100%' : '256px'"
        placeholder="Room Name"
      />
    </div>
  </div>
  <cdk-virtual-scroll-viewport
    class="overflow-auto fixed-scroll"
    [changeTrigger]="[statusFilter, dataSource]"
    [tableId]="tableId()"
    avsVirtualTableScrollNormalizer
    itemSize="1"
  >
    <cdk-virtual-scroll-viewport-wrapper>
      <table
        id="rooms-table"
        class="test-room-table main-table base-table pt-4"
        [dataSource]="dataSource"
        #tableContent
        mat-table
        matSort
        matSortActive="friendlyName"
        matSortDirection="asc"
      >
        <ng-container
          class="sticky"
          matColumnDef="position"
        >
          <th
            *matHeaderCellDef
            mat-header-cell
          >№
          </th>
          <td
            *matCellDef="let index = index"
            mat-cell
          >
            {{ index + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="room">
          <th
            [class]="isMobile() ? 'min-w-[180px]' : 'min-w-[250px]'"
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header="friendlyName"
          >
            Rooms
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            <a
              class="underline"
              routerLink="{{ element.id }}"
            >{{ element.friendlyName }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header="status"
          >Status
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            <app-entity-status [status]="element.status" />
          </td>
        </ng-container>

        <ng-container matColumnDef="incidents">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header="incidents"
          >Incidents
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            @if (element.status === eEntityStatus.Active) {
              <avs-incident-severity-count
                [critical]="element.incidentCountBySeverity.critical"
                [major]="element.incidentCountBySeverity.major"
                [minor]="element.incidentCountBySeverity.minor"
              />
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="devices">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header="devices"
          >Devices
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            @if (element.status === eEntityStatus.Active && element.devicesByStatuses) {
              <avs-status-count
                [active]="element.devicesByStatuses.activeCount"
                [paused]="element.devicesByStatuses.pausedCount"
              />
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th
            [class.hidden]="!showActionColumn()"
            [class]="isMobile() ? 'min-w-[100px]' : 'min-w-[240px]'"
            *matHeaderCellDef
            mat-header-cell
          ></th>
          <td
            class="text-ui-gray-250 text-right whitespace-nowrap"
            [class.hidden]="!showActionColumn()"
            *matCellDef="let element"
            mat-cell
          >
            <div class="flex justify-end items-center">
              @if (element.status !== eEntityStatus.Archived) {
                @if (element.externalReference) {
                  <a
                    class="inline-flex items-center action-icon mx-1"
                    [href]="element.externalReference"
                    [matTooltip]="'Doc link'"
                    target="_blank"
                  >
                    <i class="icon-link text-3xl"></i>
                  </a>
                }
                <a
                  class="mx-1 cursor-pointer action-icon"
                  (click)="editFloor(element)"
                  [showForClientAdmin]="true"
                  avsRestrictedEl
                  data-cy="edit-room"
                  matTooltip="Edit"
                >
                  <i class="icon-edit text-3xl"></i>
                </a>
                @if (element.status === eEntityStatus.Paused) {
                  <button
                    class="mx-1 cursor-pointer action-icon"
                    (click)="updateRoomStatus(element, 'Resume', eEntityStatus.Active)"
                    [showForClientAdmin]="true"
                    avsRestrictedEl
                    data-cy="resume-room"
                  >
                    <i class="icon-play-16 text-3xl"></i>
                  </button>
                }
                @if (element.status === eEntityStatus.Active) {
                  <button
                    class="mx-1 cursor-pointer action-icon"
                    (click)="updateRoomStatus(element, 'Pause', eEntityStatus.Paused)"
                    [showForClientAdmin]="true"
                    avsRestrictedEl
                    data-cy="pause-room"
                    matTooltip="Pause"
                  >
                    <i class="icon-pause-16 text-3xl"></i>
                  </button>
                }
                @if (!isMobile()) {
                  <button
                    class="mx-1 cursor-pointer action-icon"
                    (click)="updateRoomStatus(element, 'Add to Archive', eEntityStatus.Archived)"
                    avsRestrictedEl
                    data-cy="archive-room"
                    matTooltip="Archive"
                  >
                    <i class="icon-add-to-archive text-3xl"></i>
                  </button>
                }
              } @else if (!isMobile()) {
                <button
                  class="mx-1 cursor-pointer"
                  (click)="deleteRoom(element)"
                  avsRestrictedEl
                  data-cy="delete-room"
                  matTooltip="Delete"
                >
                  <i class="icon-remove text-4xl action-icon"></i>
                </button>

                @if (element.parentSpace?.status !== eEntityStatus.Archived) {
                  <button
                    class="mx-1 cursor-pointer action-icon"
                    (click)="updateRoomStatus(element, 'Restore', eEntityStatus.Active)"
                    avsRestrictedEl
                    data-cy="restore-room"
                    matTooltip="Restore"
                  >
                    <i class="icon-restore text-3xl"></i>
                  </button>
                }
              }
            </div>
          </td>
        </ng-container>

        <tr
          *matHeaderRowDef="displayedColumns; sticky: true"
          mat-header-row
        ></tr>
        <tr
          [class.is-offline]="row.status === eEntityStatus.Paused"
          *matRowDef="let row; columns: displayedColumns"
          mat-row
        ></tr>
      </table>
    </cdk-virtual-scroll-viewport-wrapper>
    @if (!dataSource.filteredData.length) {
      <avs-no-data-placeholder
        [resultContent]="!!dataSource.data.length"
        noDataText="No rooms yet"
      />
    }
  </cdk-virtual-scroll-viewport>
</mat-card-content>
